import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NgxSpinnerService } from 'ngx-spinner';
import { tap } from 'rxjs';
import { CloudTypes } from 'src/app/core/models/globals';
import { AddNode, Node } from 'src/app/core/models/node';
import { NodeNetwork } from 'src/app/core/models/nodeNetwork';
import { GatewayService } from 'src/app/core/services/gateway.service';
import { NodeService } from 'src/app/core/services/node.service';

@Component({
  selector: 'app-update-node',
  templateUrl: './update-node.component.html',
  styleUrls: ['./update-node.component.scss']
})
export class UpdateNodeComponent implements OnInit {

  nodeInfo = this.data.nodeInfo;
  nodeNetwork: NodeNetwork = {
    name: this.data.nodeNetwork.name,
    privateIp: this.data.nodeNetwork.privateIp,
    publicIp: this.data.nodeNetwork.publicIp,
    ipType: this.data.nodeNetwork.ipType,
    dns: this.data.nodeNetwork.dns,
    macAddress: this.data.nodeNetwork.macAddress,
    gatewayName: this.data.nodeNetwork.gatewayName,
    NewMachineName: this.data.nodeNetwork.NewMachineName
  }
  updateNodeForm: UntypedFormGroup = new UntypedFormGroup({
    macAddress: new UntypedFormControl(this.nodeNetwork.macAddress, [Validators.pattern("^((([0-9A-F]{2}:){5})|(([0-9A-F]{2}-){5})|([0-9A-F]{10}))([0-9A-F]{2})$")]),
    gateway: new UntypedFormControl(this.nodeNetwork.gatewayName),
    publicIp: new UntypedFormControl(this.nodeNetwork.publicIp, [Validators.pattern("^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])$")]),
    privateIp: new UntypedFormControl(this.nodeNetwork.privateIp, [Validators.pattern("^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])$")]),
    wsName: new UntypedFormControl("")
  })
  gateways = [];
  toShowDeploymentSpecificFields: boolean = this.data.depName == "NA" || (this.data.depName && (this.nodeInfo.cloudType == CloudTypes.OnPremise || this.nodeInfo.cloudType == CloudTypes.MicrosoftAzure
    || this.nodeInfo.cloudType == CloudTypes.KVM))

  constructor(
    private _gatewayService: GatewayService,
    private _spinner: NgxSpinnerService,
    private _nodeService: NodeService,
    public _dialog: MatDialogRef<UpdateNodeComponent>,
    public nodeService: NodeService,
    public snackBar: MatSnackBar,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      nodeInfo: Node,
      nodeNetwork: NodeNetwork,
      depName: string
    }) {}

  ngOnInit(): void {
    this._spinner.show("updateNode");
    if (this.nodeNetwork.ipType == "fetching...") {
      this.snackBar.open("Fetching data, please wait...", "Ok", {
        duration: 5000
      });
    }
    this.getGateways();
    // this.getNetworkInfo();
  }

  onClose(val: boolean = false){
    this._dialog.close(val);
  }

  onSubmit() {
    this._spinner.show("updateNode");
    if (this.updateNodeForm.status == "INVALID") {
      this.updateNodeForm.markAllAsTouched();
      this._spinner.hide("updateNode");
      return;
    }
    let nodeObj = new AddNode();
    if(this.toShowDeploymentSpecificFields){
      nodeObj.MacAddress = this.nodeNetwork.macAddress;
      nodeObj.IpAddress = this.nodeNetwork.privateIp;
      nodeObj.PublicIP = this.nodeNetwork.publicIp;
    }
    nodeObj.GatewayName = this.updateNodeForm.value.gateway != -1 ? this.updateNodeForm.value.gateway : null;
    nodeObj.MachineName = this.nodeInfo.vmName;
    nodeObj.DeploymentName = this.nodeInfo.depName;
    nodeObj.PlatformType = this.nodeInfo.vmPlatform;
    nodeObj.NewMachineName = this.updateNodeForm.value.wsName;
    nodeObj.NewMacAddress = this.updateNodeForm.value.macAddress;
    nodeObj.NewIpAddress = this.updateNodeForm.value.privateIp;
    nodeObj.NewPublicIP = this.updateNodeForm.value.publicIp;
    nodeObj.NewGatewayName = this.updateNodeForm.value.gateway != -1 ? this.updateNodeForm.value.gateway : null;
    nodeObj.NumberOfNodes = -1;

    this._nodeService.updateNodeDetails(nodeObj)
      .subscribe({
        next: (data) => {
          this._spinner.hide("updateNode");
        this.snackBar.open(JSON.stringify(data.actionMessage), "OK", {
          duration: 5000
        })
        this._dialog.close(true)
      },
      error: (err) => {
        this._spinner.hide("updateNode");
        this.snackBar.open(JSON.stringify(err.error.actionMessage), "OK", {
          duration: 5000
        })
        this.onClose(true);
      }
    })
  }

  getGateways() {
    this._gatewayService.getAllGateways()
      .pipe(tap(d => this._spinner.hide("updateNode")))
      .subscribe({
        next: (data) => {
          if (data) {
            this.gateways = JSON.parse(JSON.stringify(data.map(d => d.name)));
            let idx = this.gateways.findIndex(gw => gw == this.nodeNetwork.gatewayName);
            if (idx != -1) {
              this.updateNodeForm.controls["gateway"].setValue(this.gateways[idx]);
            }
          }
        },
        error: () => {}
      });
  }

  getNetworkInfo() {
    this.nodeService.getNodeNetworkInfo(this.data.nodeInfo.vmName).subscribe({
      next: (data) => {
        this.nodeNetwork = JSON.parse(JSON.stringify(data));
        this.updateNodeForm.controls["publicIp"].setValue(this.nodeNetwork.publicIp);
        this.updateNodeForm.controls["privateIp"].setValue(this.nodeNetwork.privateIp);
        this.updateNodeForm.controls["wsName"].setValue(this.nodeInfo.vmName);
        this.updateNodeForm.controls["macAddress"].setValue(this.nodeNetwork.macAddress);
      },
      error: (err) => {

      }
    })
  }
}
